// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingAction_container__2djZb","logo":"PendingAction_logo__akEH8","text":"PendingAction_text__3H-rR","pending":"PendingAction_pending__1LM-1"};